<template>
  <header class="header">
    <router-link to="/" >
           <img src="https://www.mbwsdistribution.lt/themes/degtine/assets/img/logo.png" :alt="this.metaTitle" :title="this.metaTitle"  class="header__logo" />
    </router-link>
    <div class="header__top-search top-search" :class="{'is-focused':searchFocused,'is-active':searchActive}">
      <form @submit.prevent="routeSearch" class="top-search__search">
        <input type="text" class="top-search__input" @focus="focusSearch"
          @blur="blurSearch" v-model="searchInput" ref="searchInput">
        <button class="top-search__icon">
          <search-icon class="top-search__svg" />
        </button>
      </form>
      <transition name="top-search-list">
        <div class="top-search__list" v-if="listOpen" ref="listScroller">
          <router-link class="top-search__item" :to="beverage.path" v-for="(beverage, b) in filteredBeverages"
            :key="b" @click.native="resetSearch" v-text="beverage.title"
          />
        </div>
      </transition>
    </div>
    <div class="header__search-trigger" @click="openModal('search')">
      <search-icon-mobile class="header__search-svg" />
    </div>
    <div class="header__langs langs">
      <ul class="langs__list">
        <li class="langs__item" v-if="$store.getters.ui.show_lt==1" :class="{'is-active':$store.getters.lang=='lt'}">
          <a :href="$store.getters.baseURL+'/lt'" class="langs__link">LT</a>
        </li>
        <li class="langs__item" v-if="$store.getters.ui.show_en==1" :class="{'is-active':$store.getters.lang=='en'}">
          <a :href="$store.getters.baseURL+'/en'" class="langs__link">EN</a>
        </li>
        <li class="langs__item" v-if="$store.getters.ui.show_ru==1" :class="{'is-active':$store.getters.lang=='ru'}">
          <a :href="$store.getters.baseURL+'/ru'" class="langs__link">RU</a>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import latinize from 'latinize'
import PerfectScrollbar from 'perfect-scrollbar'

import SearchIcon from '@/elements/SearchIcon'
import SearchIconMobile from '@/elements/SearchIconMobile'

import ifDefined from '@/tools/ifDefined'

export default {
  components: {
    SearchIcon,
    SearchIconMobile
  },
  computed: {
    ...mapGetters(['beverages', 'allBeverages']),
    console: () => console,
    metaTitle() {
      if (this.$store.getters.pages._) {
        return this.$store.getters.pages._.meta_title
      }
    }
  },
  data() {
    return {
      filteredBeverages: {},
      listOpen: false,
      searchActive: false,
      searchFocused: false,
      listScroller: null,
      searchInput: ''
    }
  },
  methods: {
    ...mapActions(['openModal']),
    routeSearch() {
      if (this.searchInput.length) {
        this.listOpen = false
        this.$router.push({
          path: '/search/' + latinize(this.searchInput).toLowerCase()
        })
      }
    },
    focusSearch() {
      this.searchFocused = true
      this.searchActive = true
      this.listOpen =
        Boolean(this.searchInput.length) &&
        this.searchActive &&
        this.filteredBeverages.length &&
        this.$route.name !== 'SearchResults'
    },
    blurSearch() {
      this.searchFocused = false
    },
    resetSearch() {
      this.searchActive = false
      this.searchInput = ''
      this.listOpen = false
    }
  },
  mounted() {
    if (
      this.$route.name === 'SearchResults' &&
      this.$route.params['q'].length
    ) {
      this.searchInput = this.$route.params['q']
    }
  },
  name: 'AppHeader',
  watch: {
    searchInput(input) {
      if (this.allBeverages.length) {
        this.filteredBeverages = this.allBeverages.filter(item => {
          return latinize(item['search'])
            .toLowerCase()
            .includes(latinize(input).toLowerCase())
        })
      }
      if (
        this.$route.name === 'SearchResults' &&
        this.$route.params['q'].length
      ) {
        this.routeSearch()
      }
      this.listOpen =
        Boolean(input.length) &&
        this.searchActive &&
        this.filteredBeverages.length &&
        this.$route.name !== 'SearchResults'
    },
    listOpen(isOpen) {
      if (isOpen) {
        setTimeout(() => {
          if (ifDefined(this.$refs['listScroller'])) {
            var $listScroller = this.$refs['listScroller']
            if (!this.listScroller) {
              this.listScroller = new PerfectScrollbar($listScroller)
            } else {
              this.listScroller.update()
            }
          }
        }, 0)
      } else if (this.listScroller) {
        this.listScroller = null
      }
    },
    $route(to) {
      if (to.name !== 'SearchResults') {
        this.searchActive = false
        this.searchFocused = false
        this.searchInput = ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/partials/AppHeader.vue